import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Droppable, DragDropContext, Draggable } from 'react-beautiful-dnd'
import { useDispatch } from 'react-redux'

import { reorderCategoriesSimGolf } from '../../actions'
import { GlgColorPicker } from '../../../shared/components'
import DeleteCategoryPopupSimGolf from './popups/delete_category_popup_sim_golf'

const EditCategoryComponentSimGolf = ({
  categories,
  displayDeletePopup,
  setDisplayDeletePopup,
  deleteCategory,
  name,
  setAllCategoriesData,
  addNew,
  customerId,
  setDisplayPopup,
}) => {
  const dispatch = useDispatch()
  let categoriesOpenedValues = {}
  let categoryFormData = {}

  const [allCategories, setAllCategories] = useState({})
  const [formData, setFormData] = useState(categoryFormData)
  const [openCategory, setOpenCategory] = useState(categoriesOpenedValues)

  categories && Object.values(categories).forEach( category => {
    categoriesOpenedValues[category.id] = category.opened
    categoryFormData[category.id] = {'id': category.id, 'name': category.name, 'color': category.color, 'position': Number(category.position), 'customer_id': customerId}
  })

  useEffect(() => {
    if (categories)
      if (addNew) {
        let increasePosition = {}
        Object.entries(categoryFormData).forEach(([ key ,value ]) => {
          increasePosition[key] = { ...value, 'position': value.position + 1 }
        })
        const newCategories = { ...increasePosition, [0]: { 'color': '#333333', 'id': '0', 'leagues': [], 'name': '', 'opened': true, 'position': 1, 'customer_id': customerId } }
        setFormData({ ...newCategories })
        setAllCategories({ ...newCategories })
        setOpenCategory({ [0]: true })
        setAllCategoriesData({ ...newCategories })
      } else {
        setOpenCategory({ ...categoriesOpenedValues })
        setFormData({ ...categoryFormData })
        setAllCategories(categories)
      }
  }, [addNew])

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result

    if (!destination) {
      return
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return
    } else if (destination.droppableId === source.droppableId && destination.index != source.index) {
      let newData = { ...formData }
      const currentDestination = destination.index + 1
      const currentPos = newData[draggableId].position
      const adjustment = currentPos < currentDestination

      Object.values(allCategories).forEach( category => {
        if (category.position === currentPos) {
          newData = {
            ...newData,
            [category.id]:
              {...newData[category.id], 'position': currentDestination},
          }
        } else {
          const increment = adjustment
            ? category.position <= currentDestination && category.position > currentPos ? -1 : 0
            : category.position >= currentDestination && category.position < currentPos? 1 : 0

          newData = {
            ...newData,
            [category.id]:
              { ...newData[category.id], 'position': Number(category.position + increment) },
          }
        }

      })

      setFormData({ ...newData })
      setAllCategories({ ...newData })
      setAllCategoriesData({ ...newData })
      if (!addNew) {
        dispatch(reorderCategoriesSimGolf(newData))
      }
    }
  }

  const handleOpenCategory = (id) => {
    const resetState = Object.values(openCategory).map(data => data = false)
    const newOpenCategory = {...resetState, [id]: true}
    setOpenCategory(newOpenCategory)
  }

  return (
    <DragDropContext onDragEnd={ onDragEnd }>
      <Droppable droppableId='categories'>
        { (categoriesProvided) => (
          <div
            className='categories_container'
            ref={ categoriesProvided.innerRef }
            { ...categoriesProvided.droppableProps }
          >
            { formData && Object.values(formData).sort((a, b) => a.position - b.position).map( (category, index) => {
              const closedCategory =
                <Fragment>
                  <style className='hidden'>
                    {`
                      #edit_category_item_${category.id} {
                        border-left: 4px solid ${category.color};
                      }
                    `}
                  </style>
                  <span id={ `edit_category_item_${category.id}` } className='category_name_container'>
                    <span>
                      <div className='category_name'>{ category.name }</div>
                    </span>
                    <div className='category_name_pencil_icon' onClick={ () => handleOpenCategory(category.id) }>
                      <img src={ require('pen.svg') }/>
                    </div>
                  </span>
                </Fragment>

              const openedCategory =
                <span className='category_name_opened_container'>
                  <span className='opened_container'>
                    <span className='category_name_container'>
                      <span className='hidden'>
                        <input type='number' className='hidden' name='id' defaultValue={ category.id } />
                        <input type='number' className='hidden' name='position' defaultValue={ category.position } />
                        <input type='text' className='hidden' name='customer_id' defaultValue={ customerId } />
                      </span>
                      { window.I18n.t('customer_center_comp.components.sim_golf_labels.category_name') }
                      <input
                        id={ `category_${category.id}` }
                        type='text'
                        className='category_name form-control'
                        value={ category.name }
                        placeholder={ window.I18n.t('customer_center_comp.components.sim_golf_labels.category_name') }
                        name='name'
                        autoFocus
                        onChange={ e => {
                          let newData = {
                            ...formData,
                            [category.id]:
                              { ...formData[category.id], 'name': e.target.value },
                          }
                          setFormData(newData)
                          setAllCategoriesData(newData)
                        }
                      }
                      />
                    </span>
                    <span className='category_color_container'>
                      { window.I18n.t('customer_center_comp.components.sim_golf_labels.color') }
                      <GlgColorPicker
                        className='sim_golf'
                        name='color'
                        initialColor={ category.color !== '' ? category.color : '#fff' }
                        disableAlpha={ true }
                        onChange={ color => {
                          let newData = {
                            ...formData,
                            [category.id]:
                              { ...formData[category.id], 'color': color.hex },
                          }
                          setFormData(newData)
                          setAllCategoriesData(newData)
                        }}
                      />
                    </span>
                  </span>
                  <div
                    className={`${categories[category.id] && categories[category.id].specialStatus !== null ? 'disabled' : '' } category_name_trash_icon`}
                    onClick={ () => categories[category.id] && categories[category.id].specialStatus === null && setDisplayDeletePopup(true) }
                    title={categories[category.id] && categories[category.id].specialStatus !== null && window.I18n.t('customer_center_comp.components.sim_golf_buttons.can_not_be_deleted') || '' }
                  >
                    <img src={ require('trash.svg') }/>
                  </div>
                  { displayDeletePopup &&
                    <DeleteCategoryPopupSimGolf
                      displayPopup={ displayDeletePopup }
                      setDisplayPopup={ setDisplayDeletePopup }
                      name={ name }
                      deleteCategory={ deleteCategory }
                      setDisplayDrawer={ setDisplayPopup}
                    />
                  }
                </span>

              return (
                <Draggable
                  key={ `category-${category.id}` }
                  draggableId={ String(category.id) }
                  index={ index }
                  isDragDisabled={ false }
                >
                  { (categoriesProvided, snapshot) => (
                    <div
                      key={ category.id }
                      ref={ categoriesProvided.innerRef }
                      isDragging={ snapshot.isDragging }
                      { ...categoriesProvided.dragHandleProps }
                      { ...categoriesProvided.draggableProps }
                      style={ categoriesProvided.draggableProps.style }
                      className='category_field'
                    >
                      <span className={ `category_field_container ${openCategory[category.id] ? 'opened' : ''}` }>
                        <img src={ require('grip_lines.svg') }/>
                        { openCategory[category.id] === true ? openedCategory : closedCategory }
                      </span>
                    </div>
                  ) }
                </Draggable>
              )
            })}
            {categoriesProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

EditCategoryComponentSimGolf.propTypes = {
  categories: PropTypes.object.isRequired,
  displayDeletePopup: PropTypes.bool.isRequired,
  setDisplayDeletePopup: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  name: PropTypes.string,
  setAllCategoriesData: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  setDisplayPopup: PropTypes.func.isRequired,
  addNew: PropTypes.bool,
}

export default EditCategoryComponentSimGolf
